module.exports = __webpack_public_path__ + "static/2automotive-a3a234a9cf59bb2f9166d4886a08acb8.png";